import styled, { keyframes, css } from 'styled-components';
import Box from 'elements/Box';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const Skeleton = styled(Box)<SkeletonProps>`
  border-radius: ${({ variant }) => (variant === 'circle' ? '50%' : '5px')};
  animation: ${shimmer} 2s infinite linear;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.muted} 4%,
    ${({ theme }) => theme.colors.highlight} 25%,
    ${({ theme }) => theme.colors.muted} 36%
  );
  background-size: 1000px 100%;

  ${({ variant, size }) =>
    variant === 'circle' &&
    css`
      width: ${size}px;
    `}
`;

Skeleton.defaultProps = {
  size: 40,
  width: 1 / 1,
  variant: 'rectangle'
};

type SkeletonProps = {
  size?: number;
  variant?: 'circle' | 'rectangle';
};

export default Skeleton;
